import { type AssignedTask, TaskV2 } from '@/models/registry';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';

const useTasksStats = (assignedTasks: AssignedTask[] | TaskV2[]) => {
  const hasAssignedTasks = useMemo(() => {
    return !isEmpty(assignedTasks);
  }, [assignedTasks]);

  const numberOfTasksDone = useMemo(() => {
    return assignedTasks.filter((task) => task.status === 'done').length;
  }, [assignedTasks]);

  const completedPercentage = useMemo(() => {
    return (numberOfTasksDone / assignedTasks.length) * 100;
  }, [numberOfTasksDone, assignedTasks]);

  return { hasAssignedTasks, numberOfTasksDone, completedPercentage };
};

export const useTasksStatsV2 = (assignedTasks: TaskV2[]) => {
  const done = assignedTasks.filter((t) => t.status === 'done').length;
  const total = assignedTasks.length;

  return {
    hasAssignedTasks: total > 0,
    numberOfTasksDone: done,
    completedPercentage: total ? (done / total) * 100 : 0,
  };
};

export default useTasksStats;
